var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-cascader',{attrs:{"options":_vm.animal,"load-data":_vm.loadAnimalData,"change-on-select":"","placeholder":_vm.placeholder},on:{"change":_vm.onChange},model:{value:(_vm.selectedAnimal),callback:function ($$v) {_vm.selectedAnimal=$$v},expression:"selectedAnimal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }